/** 403 Forbidden — wrong role or insufficient permission */
import { createFileRoute, Link } from '@tanstack/react-router';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/403')({
  component: ForbiddenPage,
});

function ForbiddenPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <ShieldX className="h-16 w-16 text-destructive" />
      <h1 className="text-2xl font-bold">Không có quyền truy cập</h1>
      <p className="text-muted-foreground text-sm max-w-sm">
        Bạn không có quyền xem trang này. Vui lòng liên hệ quản trị viên.
      </p>
      <Button asChild variant="outline">
        <Link to="/">Về trang chủ</Link>
      </Button>
    </div>
  );
}
